import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    /**
     * @description 手机验证码
     * @param {Object} data 手机号
     */
    registerCode: function registerCode() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                return _context.abrupt("return", request({
                  url: '/store/registerCode',
                  data: data
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 注册
     * @param {Object} data
     */
    register: function register() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/store/register',
        data: data
      });
    },

    /**
     * @description 申请入驻
     * @param {Object} data
     */
    apply: function apply() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/store/apply',
        data: data
      });
    },

    /**
     * @description 品牌列表
     * @param {Object} data
     */
    brands: function brands() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/store/brands',
        data: data
      });
    },

    /**
     * @description 获取门店、店铺保证金缴纳金额、银行账户
     * @param {Object} data
     */
    depositInfo: function depositInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/finance/depositInfo',
        data: data
      });
    }
  };
});